import { render, staticRenderFns } from "./AboutStats.vue?vue&type=template&id=7be71ec9&scoped=true&"
var script = {}
import style0 from "./AboutStats.vue?vue&type=style&index=0&id=7be71ec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be71ec9",
  null
  
)

export default component.exports